<template>

  <div class="box-userprofiledata">
    <UserProfileSteps></UserProfileSteps>
    <div class="container">
      <div class="row row-responsive">
        <div class="column column-xs-100 column-sm-80 column-offset-sm-10">
          <div class="box-step" v-if="$store.getters.getCurrentStep === 0">
            <Step1></Step1>
          </div>
          <div class="box-step" v-if="$store.getters.getCurrentStep === 1">
            <Step2></Step2>
          </div>
          <div class="box-step" v-if="$store.getters.getCurrentStep === 2">
            <Step3></Step3>
          </div>
          <div class="box-step" v-if="$store.getters.getCurrentStep === 3">
            <Step4></Step4>
          </div>
          <div class="box-step" v-if="$store.getters.getCurrentStep === 4">
            <Step5></Step5>
          </div>
          <div class="box-step" v-if="$store.getters.getCurrentStep === 5">
            <Step6></Step6>
          </div>
          <div class="box-step" v-if="$store.getters.getCurrentStep === 6">
            <Step7></Step7>
          </div>
          <div class="box-step" v-if="$store.getters.getCurrentStep === 7">
            <Step8></Step8>
          </div>
          <div class="box-step" v-if="$store.getters.getCurrentStep === 8">
            <Step9></Step9>
          </div>
          <div class="box-step" v-if="$store.getters.getCurrentStep === 9">
            <Step10 />
          </div>
          <div class="box-step" v-if="$store.getters.getCurrentStep === 10">
            <PepHandler />
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import UserProfileSteps from './UserProfileSteps'
import Step1 from '@/views/userProfile/profileSteps/StepGeneralInfo'
import Step2 from '@/views/userProfile/profileSteps/StepAddress'
import Step3 from '@/views/userProfile/profileSteps/StepCellphoneConfirmation'
import Step4 from '@/views/userProfile/profileSteps/StepIdentityProof'
import Step5 from '@/views/userProfile/profileSteps/StepTransaction'
import Step6 from '@/views/userProfile/profileSteps/StepProfession'
import Step7 from '@/views/userProfile/profileSteps/StepBeneficiaries'
import Step8 from '@/views/userProfile/profileSteps/StepAnnex'
import Step9 from '@/views/userProfile/profileSteps/StepContract'
import Step10 from '@/views/userProfile/profileSteps/StepSuccess'

import PepHandler from '@/views/userProfile/profileSteps/PepHandler'
import StepIndirectPep from '@/views/userProfile/profileSteps/StepIndirectPep'

import Vue from 'vue'
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

export default {
  name: 'UserProfile',
  data () {
    return {}
  },
  components: {
    PepHandler,
    StepIndirectPep,
    UserProfileSteps,
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
    Step6,
    Step7,
    Step8,
    Step9,
    Step10
  }
}
</script>

<style lang="scss">

.main-title {
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #ccc;
  font-weight: 300;
}

.box-step {
  padding: 2rem 0;
  border: 1px solid #ccc;
  background-color: #efefef;
  border-radius: 6px;
}

input.error-label,
select.error-label {
  border-color: $red;
}

.box-userprofiledata .vdp-datepicker__calendar .cell.selected {
  background: $green;

  &:hover {
    background: $midnight-blue;
    color: $white;
  }
}

.box-userprofiledata .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
.box-userprofiledata .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
.box-userprofiledata .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
  border: 1px solid $green;
}

</style>



// WEBPACK FOOTER //
// src/views/userProfile/UserProfileForm.vue